export const RewardTierTypes = {
  STANDARD: 'standard',
  CORPORATE: 'corporate',
  CUSTOM: 'custom',
  INDIVIDUAL: 'individual',
} as const;

export type RewardTierType =
  (typeof RewardTierTypes)[keyof typeof RewardTierTypes];

export type CreateRewardTierData = {
  name: string;
  type: RewardTierType;
  registrationFee: number;
  prize: number;
  status: string;
  parThree: number | null;
  playerCount: number | null;
};

export type RewardTier = CreateRewardTierData & {
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type RewardTierStatusOption = {
  id: string;
  name: string;
};

export const RewardTierStatuses = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export type RewardTierStatus =
  (typeof RewardTierStatuses)[keyof typeof RewardTierStatuses];
